import {
  GET_ADMIN_DASHBOARD_REQUEST,
  GET_ADMIN_DASHBOARD_SUCCESS,
  GET_ADMIN_DASHBOARD_FAILURE,
  CLEAR_DASHBOARD_DATA
} from '../../constants/dashboard/dashboardConstants';

const initialState = {
  data: null,
  loading: false,
  error: null
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_DASHBOARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_ADMIN_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null
      };
    case GET_ADMIN_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case CLEAR_DASHBOARD_DATA:
      return initialState;
    default:
      return state;
  }
};

export default dashboardReducer;